import { useAppDispatch, useAppSelector } from "@/Hook/hooks";
// import { getUserInsights } from "@/Redux/Ducks/dashboardSlice";
import { getHomeUserSpecificData, storeHomeLayout, toggleDesignMode } from "@/Redux/Ducks/homeSlice";
import { getNotification } from "@/Redux/Ducks/inboxSlice";
import { ArrayKeyValueObject } from "@/UI/Interfaces/IBaseUI";
import { useEffect, useState } from "react";
import ActiveApproval from "./ActiveApproval";
import Favorites from "./Favorites";
import FrequentlyUsed from "./FrequentlyUsed";
import { AlignUIRender } from "./indexUI";
import MyTasks from "./MyTasks";
import SelfService from "./SelfService";
import MyGoals from "./MyGoals";
import Events from "./Events";
import Announcements from "./Announcements";

const widgetsConf = [
  {
    id: "selfservice",
    component: <SelfService />,
  },
  {
    id: "activeapproval",
    component: <ActiveApproval />,
  },
  {
    id: "favorites",
    component: <Favorites />,
  },
  {
    id: "frequentlyused",
    component: <FrequentlyUsed />
  },
  {
    id: "mytasks",
    component: <MyTasks />
  },
  {
    id: "mygoals",
    component: <MyGoals />
  },
  {
    id: "events",
    component: <Events />
  },
  {
    id: "announcements",
    component: <Announcements />
  }
]

const Home = () => {
  const dispatch = useAppDispatch();

  const { dataLoaded, designMode, userWidgets, userLayout, isEmployee, userName } = useAppSelector(state => {
    return {
      dataLoaded: state.Home.dataLoaded,
      designMode: state.Home.designMode,
      userWidgets: state.Home.userWidgets,
      userLayout: state.Home.userLayout,
      isEmployee: state.User.user.usercategoryno?.isEqual("CON"),
      userName: state.User.user.name,
    }
  });

  const [widgetsComponents, setWidgetComponents] = useState<ArrayKeyValueObject>([]);
  const [widgetMenuOpen, toggleWidgetMenuState] = useState<boolean>(false);
  const [layout, setLayout] = useState<ArrayKeyValueObject>([]);
  const [widgets, setWidgets] = useState<Array<string>>([]);

  useEffect(() => {
    setLayout(userLayout);
    setWidgets(userWidgets);
    setWidgetComponents(widgetsConf
      .map(({ id, ...rest }) => ({ id, ...rest, visible: widgets.includes(id) }))
    );
  }, [userWidgets, userLayout])

  useEffect(() => {
    if (!designMode) {
      setLayout(userLayout);
      setWidgets(userWidgets);
      setWidgetComponents(widgetsConf.map(({ id, ...rest }) => ({ id, ...rest, visible: userWidgets.includes(id) })));
    }
  }, [designMode])

  useEffect(() => {
    if (!dataLoaded) {
      dispatch(getHomeUserSpecificData());
      // dispatch(getUserInsights());
      dispatch(getNotification({ key: "/approval/active", reload: true, searchParam: '' }));
    }
  }, [dataLoaded]);

  const saveLayout = () => {
    dispatch(storeHomeLayout({ widgets, layout }));
  }

  const closeDesignMode = () => {
    dispatch(toggleDesignMode(false))
  }

  const openWidgetMenu = () => {
    toggleWidgetMenuState(true);
  }

  const closeWidgetMenu = () => {
    toggleWidgetMenuState(false);
  }

  const onLayoutChange = (layout: any) => {
    setLayout(layout);
  }

  const removeWidget = (wId: string) => {
    setWidgets(widgets.filter(w => w != wId));
    setWidgetComponents(widgetsConf.map(({ id, ...rest }) => ({ id, ...rest, visible: widgets.includes(id) })));
  }

  const addWidget = (wId: string) => {
    setWidgets([...widgets, wId]);
    setWidgetComponents(widgetsConf.map(({ id, ...rest }) => ({ id, ...rest, visible: widgets.includes(id) })));
  }

  return AlignUIRender({ dataLoaded, isEmployee, userName, designMode, saveLayout, widgetMenuOpen, widgetsComponents, addWidget, removeWidget, layout, onLayoutChange, closeDesignMode, openWidgetMenu, closeWidgetMenu });
};

export default Home;
